import { GenericAppError } from '@/components/generic-app-error';
import { AuthService } from '@/services/authService';
import { useAuthStore } from '@/store/auth';
import { createFileRoute, Outlet, redirect, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AuthProvider } from 'react-oidc-context';

export const Route = createFileRoute('/_auth')({
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: 'breadcrumbs.home',
      }),
    };
  },
  beforeLoad: async ({ location, context }) => {
    // the access token may have expired while the user was away (e.g. at THEQA signing) with the session still alive
    if (AuthService.isTokenExpired() && (await context.authStore.getState().authService?.renewExpiredSession())) {
      console.debug(`[/_auth${location.pathname}]: Expired access token renewed.`);
    }

    if (AuthService.isTokenExpired()) {
      AuthService.handleTokenExpired();
      console.debug(`[/_auth${location.pathname}]: User is not authenticated. Redirecting to login...`);

      // Capture the current location for redirect after login
      const currentPath = location.pathname + location.searchStr;
      throw redirect({
        to: '/login',
        search: {
          redirect: currentPath,
        },
      });
    } else {
      console.debug(`[/_auth${location.pathname}]: User is authenticated.`);
    }
  },
  component: RootComponent,
  errorComponent: GenericAppError,
});

function RootComponent() {
  const navigate = useNavigate();
  const { authService } = useAuthStore((state) => state);

  useEffect(() => {
    return authService?.oidcClient.events.addAccessTokenExpired(() => {
      authService.signout();
    });
  }, [authService, authService?.oidcClient, navigate]);

  return (
    <AuthProvider userManager={authService?.oidcClient}>
      <div className="flex-1">
        <Outlet />
      </div>
    </AuthProvider>
  );
}
